<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">


            <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
                <FormItem label="上传图片：" prop="bannerUrl">
                    <div class="j-img-echo">
                        <template v-if="!params.bannerUrl">
                            <Icon type="md-images" size="55" color="#c5c8ce" />
                        </template>
                        <template v-else>
                            <img :src="params.bannerUrl">
                        </template>
                    </div>
                    <Upload :action="action" :headers="headers" :show-upload-list="false" name="file" :on-success="uploadSuccess">
                        <Button icon="ios-cloud-upload-outline" style="width:488px">上传Banner</Button>
                    </Upload>
                    <Alert show-icon closable style="margin-top:10px">建议上传1010*404尺寸并且大小不能大于500kb的图片</Alert>
                </FormItem>
                <FormItem label="跳转类型：" prop="jumpType">
                    <Select v-model="params.jumpType" placeholder="跳转类型" clearable @on-change="jumpTypeChange">
                        <Option value="0">无</Option>
                        <Option value="1">URL</Option>
                        <Option value="2">Page</Option>
                    </Select>
                </FormItem>
                <FormItem label="展示位置：" prop="bannerPosition">
                  <Select v-model="params.bannerPosition" placeholder="展示位置" clearable>
                    <Option value="1">banner</Option>
                    <Option value="2">弹窗</Option>
                  </Select>
                </FormItem>
                <FormItem label="跳转值：" prop="jumpUrl">
                    <Input v-model.trim="params.jumpUrl" :disabled="jumpUrlDis" placeholder="请输入跳转链接"></Input>
                </FormItem>
                <FormItem label="排序：" prop="bannerIndex">
                    <Input v-model.trim="params.bannerIndex" placeholder="请输入banner排序" type="number"></Input>
                </FormItem>
            </Form>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "banner-ope",
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                usernameDis: false,
                jumpUrlDis: true,
                action: this.$uploadURL,
                headers: {
                    token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
                },
                title: '查看信息',
                type: 0,
                params: {
                    bannerUrl: '',
                    bannerIndex: '999',
                    jumpUrl: '',
                    jumpType: '0',
                    bannerId: '',
                    bannerPosition: '1'
                },
                ruleValidate: {
                    bannerUrl: [
                        {required: true, message: 'banner图片不能为空', trigger: 'change'},
                    ],
                    bannerIndex: [
                        {required: true, message: 'banner排序不能为空', trigger: 'change'}
                    ],
                    bannerPosition: [
                      {required: true, message: 'banner展示位置不能为空', trigger: 'change'}
                    ]
                }
            }
        },
        methods: {
            // 点击提交验证
            handleSubmit(name) {
                // console.log(this.params);
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // this.$Message.error('验证通过');
                        /**
                         * type判断
                         * 1.查看 2.新增 3.编辑
                         */
                        switch (this.type) {
                            case 1:
                                // this.title = '查看banner';
                                break;
                            case 2:
                                // 新增banner
                                this.addBanner();
                                break;
                            case 3:
                                // 编辑banner
                                this.updateBanner();
                                break;
                            default:
                                this.$Notice.error({
                                    title: 'banner管理',
                                    desc: '查看，新增，编辑区分判断报错',
                                    duration: 0
                                });
                                break
                        }
                    } else {
                        this.$Message.error('还有信息没有填写合格哦~');
                    }
                })
            },
            // 显示模态框
            show(type, row) {
                this.isShowModal = true;
                this.type = type;
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                switch (type) {
                    case 1:
                        this.title = '查看banner';
                        this.findBannerById(row);
                        break;
                    case 2:
                        this.title = '新增banner';
                        break;
                    case 3:
                        this.title = '编辑banner';
                        this.findBannerById(row);
                        break;
                    default:
                        this.$Notice.error({
                            title: 'banner管理',
                            desc: '查看，新增，编辑模态框报错',
                            duration: 0
                        });
                        break
                }
            },
            // 新增banner
            addBanner() {
                this.$Spin.show();
                this.axios.post('/banner/addBanner', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '新增banner接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 编辑banner
            updateBanner(){
                this.$Spin.show();
                this.axios.post('/banner/updateBanner', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '编辑banner接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 查询banner详情
            findBannerById(row){
                this.$Spin.show();
                this.axios.post('/banner/findBannerById', {
                    bannerId: row.bannerId
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        // this.$Message.success('操作成功.');
                        this.params.bannerUrl = res.data.bannerUrl;
                        this.params.bannerIndex = res.data.bannerIndex.toString();
                        this.params.jumpUrl = res.data.jumpUrl;
                        this.params.jumpType = res.data.jumpType.toString();
                        this.params.bannerId = res.data.bannerId;
                        this.params.bannerPosition = res.data.bannerPosition.toString();
                        this.usernameDis = true;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查看banner详情接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 上传成功
            uploadSuccess(response, file, fileList){
                if (response.status == 200) {
                    this.params.bannerUrl = response.data;
                }
                if(response.status == 201){
                    this.$Message.error(response.msg);
                }
                if (response.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '上传banner接口报错',
                        duration: 0
                    });
                }
            },
            // 修改跳转类型
            jumpTypeChange(e){
                this.params.jumpUrl = '';
                if(e != 0){
                    this.jumpUrlDis = false;
                }else{
                    this.jumpUrlDis = true;

                }
            },
            // 关闭模态框
            hide(name) {
                this.isShowModal = false;
                this.params.bannerId = '';
                this.usernameDis = false;
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>

</style>